module.exports = __webpack_public_path__ + "img/spinning-gear.02b5f649.webp";